import { render } from "./ProjectContext.vue?vue&type=template&id=145598df&scoped=true"
import script from "./ProjectContext.vue?vue&type=script&lang=js"
export * from "./ProjectContext.vue?vue&type=script&lang=js"

import "./ProjectContext.vue?vue&type=style&index=0&id=145598df&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145598df"]])

export default __exports__